import type { PaymentMethodResponse } from "@interfaces/heap-api";

export enum CheckoutStep {
    CONTACT_DETAILS = 0,
    DELIVERY = 1,
    PAYMENT = 2,
}

export enum ShippingMethodTypes {
    CLICK_AND_COLLECT = "CC",
    TRY_AND_BUY = "CR",
    HOME_DELIVERY = "HD",
    JAPAN_CLICK_AND_COLLECT = "JP-CC",
    PARCEL_SHOP = "PS",
}

export interface ShippingMethod {
    key: string;
    marketKey: string;
    type: ShippingMethodTypes;
}

export const DELIVERY_METHODS_DICTIONARY: Record<string, ShippingMethod[]> = {
    "jp.ecco.com": [{ key: "CC", marketKey: "JP-CC", type: ShippingMethodTypes.CLICK_AND_COLLECT }],
};

export type TPaymentMethods = {
    name: string;
    type: string;
    brands?: string[];
    _Configuration?: {
        // GooglePay uses gatewayMerchantId
        gatewayMerchantId?: string;
        // ApplePay uses merchantId
        merchantId?: string;
        merchantName: string;
    };
};

export type TAmazonPayHeapMethod = {
    name: string;
    storeId: string;
    merchantId: string;
    // Pre-serialized JSON payload signed by HEAP — must be passed to Amazon verbatim.
    payloadJSON: string;
    signature: string;
    checkoutLanguage: string;
    publicKeyId: string;
    currency: string;
};

export type THeapPaymentMethodsJson =
    | {
          PaymentProviderType: "Adyen" | "NoPay";
          paymentMethods: TPaymentMethods[];
      }
    | {
          PaymentProviderType: "AmazonPay";
          paymentMethods: TAmazonPayHeapMethod[];
      };

export type THeapPaymentMethodsResponse = PaymentMethodResponse & {
    parsedPaymentMethodsJson: THeapPaymentMethodsJson[]; // This is the parsed version of the payment methods, ready for use in the application.
};
